/* KACHING AIRVITA NUKE v2
 * Fix: wait img loaded, liquid glass behind frosted image, gradient border, mobile padding.
 */
(function () {
  'use strict';

  function showDebug(msg) {
    // silenzioso in production
  }

  var MAX_TRIES = 200;
  var WAIT_MS = 200;

  // map productGID → image URL leggendo i config JSON Kaching
  function buildProductImageMap() {
    var map = {};
    document.querySelectorAll('script.kaching-bundles-product').forEach(function (s) {
      try {
        var data = JSON.parse(s.textContent);
        if (data && data.id && data.image) {
          var url = data.image;
          if (url.indexOf('//') === 0) url = 'https:' + url;
          map[String(data.id)] = url;
        }
      } catch (e) {}
    });
    return map;
  }

  function readState() {
    var block = document.querySelector('.pdp-offer .kaching-bundles__block');
    if (!block) return null;
    // procedo anche senza --loaded; più sotto verifico bars > 0

    var imgMap = buildProductImageMap();
    // A/B: l'HTML statico contiene i settings di TUTTE le varianti del test.
    // Scelgo lo script i cui dealBars combaciano (numero + id) con le bar
    // idratate da Kaching nel DOM: è la config della variante che il
    // visitatore sta davvero vedendo.
    var _domBarIds = [];
    block.querySelectorAll('.kaching-bundles__bars .kaching-bundles__bar').forEach(function (b) {
      if (!b.closest('.kaching-bundles__checkbox-upsells') && b.dataset.dealBarId) _domBarIds.push(b.dataset.dealBarId);
    });
    function _matchesDom(s) {
      var ids = ((s && s.dealBars) || []).map(function (b) { return b.id; });
      return _domBarIds.length > 0 && ids.length === _domBarIds.length &&
        _domBarIds.every(function (id) { return ids.indexOf(id) > -1; });
    }
    var dealBlockSettings = null;
    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(function (s) {
      if (dealBlockSettings) return;
      try { var _p = JSON.parse(s.textContent); if (_matchesDom(_p)) dealBlockSettings = _p; } catch (e) {}
    });
    window.__abSettings = dealBlockSettings;

    // map mediaImageGID → url leggendo l'attribute media-images del custom element
    var mediaMap = window.__abMediaMap || (window.__abMediaMap = {});
    var blockEl = document.querySelector('kaching-bundles-block');
    if (blockEl) {
      var mi = blockEl.getAttribute('media-images');
      if (mi) {
        try {
          var arr = JSON.parse(mi);
          arr.forEach(function (m) { if (m && m.gid && m.url) mediaMap[m.gid] = m.url; });
        } catch (e) {}
      }
    }
    // capture: ad ogni gift unlocked nel DOM, salva img.src per uso futuro quando locked
    var giftImgCache = window.__abGiftImgCache || (window.__abGiftImgCache = {});
    block.querySelectorAll('.kaching-bundles__progressive-gifts__gift:not(.kaching-bundles__progressive-gifts__gift--locked)').forEach(function (g, i) {
      var idxFromDom = Array.prototype.indexOf.call(block.querySelectorAll('.kaching-bundles__progressive-gifts__gift'), g);
      var img = g.querySelector('img');
      if (img && img.src && img.src.indexOf('Kaching-Bundles') > -1) {
        giftImgCache[idxFromDom] = img.src;
      }
    });

    // dealBars config gives us productGID / variantGID fallback for tier images
    var dealBars = (dealBlockSettings && dealBlockSettings.dealBars) || [];
    var configMatchesDom = !!dealBlockSettings; // settings già selezionati sulla variante idratata
    window.__abConfigMatchesDom = configMatchesDom;
    function gidToId(gid) { var m=String(gid||'').match(/(?:Product|ProductVariant)\/(\d+)/); return m?m[1]:null; }

    var bars = block.querySelectorAll('.kaching-bundles__bars .kaching-bundles__bar');
    var tiers = [];
    bars.forEach(function (bar, idx) {
      if (bar.closest('.kaching-bundles__checkbox-upsells')) return;
      var radio = bar.querySelector('input[type="radio"]');
      var imgEl = bar.querySelector('.kaching-bundles__bar-image');
      var titleEl = bar.querySelector('.kaching-bundles__bar-title');
      var subEl = bar.querySelector('.kaching-bundles__bar-subtitle');
      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      var fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
      var labelEl = bar.querySelector('.kaching-bundles__bar-label')
                 || bar.querySelector('.kaching-bundles__bar-most-popular__content')
                 || bar.querySelector('.kaching-bundles__bar-most-popular');

      // image fallback dal config product
      var domImg = imgEl && imgEl.src && imgEl.src.indexOf('data:') !== 0 ? imgEl.src : '';
      var fallbackImg = '';
      var dealCfg = dealBars[idx];
      if (dealCfg) {
        var prodId = gidToId(dealCfg.productGID) || gidToId(dealCfg.variantGID);
        // primo tier: usa il prodotto principale
        if (!prodId) {
          var mainProductScript = document.querySelector('script.kaching-bundles-product[data-main="true"]');
          if (mainProductScript) {
            try { prodId = String(JSON.parse(mainProductScript.textContent).id); } catch(e){}
          }
        }
        if (prodId && imgMap[prodId]) fallbackImg = imgMap[prodId];
      }

      tiers.push({
        radioId: radio ? radio.id : null,
        barId: bar.dataset.dealBarId,
        img: domImg || fallbackImg,
        title: titleEl ? titleEl.textContent.trim() : '',
        subtitle: subEl ? subEl.textContent.trim() : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        fullPrice: fullEl ? fullEl.textContent.trim() : '',
        label: labelEl ? labelEl.textContent.trim() : '',
        selected: bar.classList.contains('kaching-bundles__bar--selected')
      });
    });

    var upsell = null;
    var upsellEl = block.querySelector('.kaching-bundles__checkbox-upsells__upsell');
    if (upsellEl) {
      var uCheckbox = upsellEl.querySelector('input[type="checkbox"]') || upsellEl.querySelector('[role="checkbox"]');
      var uImg = upsellEl.querySelector('.kaching-bundles__checkbox-upsells__image');
      var uDomImg = uImg && uImg.src ? uImg.src : '';
      // fallback upsell image dal config
      var uFallback = '';
      var upCfgs = (dealBlockSettings && dealBlockSettings.checkboxUpsells && dealBlockSettings.checkboxUpsells.upsells) || [];
      if (upCfgs[0]) {
        var upId = gidToId(upCfgs[0].productGID);
        if (upId && imgMap[upId]) uFallback = imgMap[upId];
      }
      upsell = {
        el: upsellEl,
        img: uDomImg || uFallback,
        title: upsellEl.querySelector('.kaching-bundles__bar-title')?.textContent.trim() || '',
        price: upsellEl.querySelector('.kaching-bundles__bar-price')?.textContent.trim() || '',
        fullPrice: upsellEl.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim() || '',
        checked: uCheckbox ? (uCheckbox.checked || uCheckbox.getAttribute('aria-checked') === 'true') : false
      };
    }

    var gifts = [];
    var giftEls = block.querySelectorAll('.kaching-bundles__progressive-gifts__gift');

    // estraggo productGID per ogni gift dal config dealBlockSettings (ordine = stesso del DOM)
    var giftConfigs = configMatchesDom && dealBlockSettings && dealBlockSettings.progressiveGifts && dealBlockSettings.progressiveGifts.gifts || [];
    function gidToProductId(gid) {
      var m = String(gid || '').match(/Product\/(\d+)/);
      return m ? m[1] : null;
    }
    function realTitleFor(idx) {
      var cfg = giftConfigs[idx];
      if (!cfg) return null;
      var pid = gidToProductId(cfg.productGID);
      if (!pid) return null;
      var script = document.querySelector('script.kaching-bundles-product[data-product-id="' + pid + '"]');
      if (!script) return null;
      try { return JSON.parse(script.textContent).title || null; } catch (e) { return null; }
    }

    giftEls.forEach(function (g, idx) {
      var locked = g.classList.contains('kaching-bundles__progressive-gifts__gift--locked');
      var imgEl = g.querySelector('img');
      var imgFromDom = imgEl && imgEl.src ? imgEl.src : '';
      // se locked, l'img DOM non c'è (è SVG lucchetto). Prendo dalla mediaImageGID del config.
      var imgFromConfig = '';
      var cfg = giftConfigs[idx];
      if (cfg) {
        // PRIORITÀ: mediaImageGID (image specifica del widget Kaching) > productGID
        if (cfg.mediaImageGID && mediaMap[cfg.mediaImageGID]) {
          imgFromConfig = mediaMap[cfg.mediaImageGID];
        } else {
          var pid = gidToProductId(cfg.productGID);
          if (pid && imgMap[pid]) imgFromConfig = imgMap[pid];
        }
      }
      // Cache fallback: l'immagine catturata quando questo gift era unlocked
      var imgFromCache = giftImgCache[idx] || '';
      var finalImg = imgFromDom || imgFromCache || imgFromConfig;

      // titolo: se locked, prendo dal product config (es. "Spedizione GRATUITA"), altrimenti dal DOM
      var domTitle = g.querySelector('.kaching-bundles__progressive-gifts__gift__title')?.textContent.trim() || '';
      var titleFinal = (!locked && domTitle) ? domTitle : (realTitleFor(idx) || domTitle || 'Bloccato');

      gifts.push({
        locked: locked,
        img: finalImg,
        title: titleFinal,
        labelText: g.querySelector('.kaching-bundles__progressive-gifts__gift__label__text:not(.kaching-bundles__progressive-gifts__gift__label__text--crossed-out)')?.textContent.trim() || 'Gratis',
        crossed: g.querySelector('.kaching-bundles__progressive-gifts__gift__label__text--crossed-out')?.textContent.trim() || ''
      });
    });

    var giftsTitle = block.querySelector('.kaching-bundles__progressive-gifts__title')?.textContent.trim() || '';
    var giftsSub = block.querySelector('.kaching-bundles__progressive-gifts__subtitle')?.textContent.trim() || '';

    return { tiers: tiers, upsell: upsell, gifts: gifts, giftsTitle: giftsTitle, giftsSub: giftsSub, block: block };
  }

  function allImagesReady(state) {
    if (!state) return false;
    // solo verifica che src non sia vuoto — non aspetto load
    for (var i = 0; i < state.tiers.length; i++) if (!state.tiers[i].img) return false;
    if (state.upsell && !state.upsell.img) return false;
    // gifts: anche locked need img per liquid glass — ma se Kaching non ha img per locked, ok
    return true;
  }

  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // Lock split in 2 parts: shackle (arco) e body. Permette animazione "apertura".
  var LOCK_SVG = '<svg viewBox="0 0 24 24" class="ab-lock" aria-hidden="true">' +
    '<path class="ab-lock-shackle" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M8 11V7a4 4 0 0 1 8 0v4"/>' +
    '<rect class="ab-lock-body" fill="currentColor" x="4.5" y="11" width="15" height="11" rx="2"/>' +
    '</svg>';

  function formatGiftTitle(s) {
    if (!s) return '';
    // sostituisci " GRATUITA"/" Argos"/" Silenziose" → <br>... per multilinea
    var formatted = escapeHTML(s);
    // split su "Spedizione GRATUITA" → due righe
    formatted = formatted.replace(/^(Spedizione)\s+(GRATUITA)$/i, '$1<br>$2');
    // split "Guanto Toelettatura Argos" → "Guanto Toelettatura<br>Argos"
    formatted = formatted.replace(/^(Guanto\s+Toelettatura)\s+(Argos)$/i, '$1<br>$2');
    // split "Kit Ricambio x3 - Testine Silenziose"
    formatted = formatted.replace(/^(Kit\s+Ricambio\s+x\d+)\s*-\s*(.+)$/i, '$1<br>$2');
    // split "GARANZIA di 1 Anno"
    formatted = formatted.replace(/^(GARANZIA)\s+(di\s+1\s+Anno)$/i, '$1<br>$2');
    // split "1 Argos Trim Pro + 3 Testine Silenziose"
    formatted = formatted.replace(/^(1\s+Argos\s+Trim\s+Pro)\s*\+\s*(.+)$/i, '$1<br>+ $2');
    return formatted;
  }

  function buildGiftHTML(g) {
    var classes = 'ab-gift ' + (g.locked ? 'ab-gift-locked' : 'ab-gift-unlocked');
    var inner = '';
    inner += '<span class="ab-gift-badge">' + escapeHTML(g.labelText) + (g.crossed ? '<span class="ab-gift-x">' + escapeHTML(g.crossed) + '</span>' : '') + '</span>';
    inner += '<div class="ab-gift-img">';
    if (g.img) {
      inner += '<img class="ab-gift-real" src="' + g.img + '" alt="">';
    }
    if (g.locked) {
      inner += '<div class="ab-lock-overlay">' + LOCK_SVG + '</div>';
    }
    inner += '</div>';
    inner += '<div class="ab-gift-name">' + formatGiftTitle(g.title) + '</div>';
    return '<div class="' + classes + '">' + inner + '</div>';
  }

  function parsePrice(s) {
    if (!s) return 0;
    var clean = String(s).replace(/[^0-9,.\-]/g, '').replace(/\./g, '').replace(/,/g, '.');
    var n = parseFloat(clean);
    return isNaN(n) ? 0 : n;
  }

  function calcDiscount(price, fullPrice) {
    var p = parsePrice(price);
    var f = parsePrice(fullPrice);
    if (!p || !f || f <= p) return 0;
    return Math.round((1 - p / f) * 100);
  }

  function buildHTML(state) {
    var html = '<div class="ab-bundle">';

    html += '<div class="ab-tiers">';
    state.tiers.forEach(function (t) {
      var isPopular = !!t.label;
      var disc = calcDiscount(t.price, t.fullPrice);
      html += '<div class="ab-tier' + (t.selected ? ' ab-sel' : '') + (isPopular ? ' ab-pop' : '') + '" data-radio-id="' + (t.radioId || '') + '" data-bar-id="' + (t.barId || '') + '">';
      if (isPopular) html += '<div class="ab-ribbon">' + escapeHTML(t.label || 'Più acquistato') + '</div>';
      html += '<div class="ab-img-wrap"><img class="ab-img" src="' + t.img + '" alt=""></div>';
      html += '<div class="ab-ctr">';
      html += '<div class="ab-title">' + escapeHTML(t.title);
      if (isPopular && disc > 0) html += ' <span class="ab-discount-pill">−' + disc + '%</span>';
      html += '</div>';
      if (t.subtitle) html += '<div class="ab-sub' + (isPopular ? ' ab-sub-pop' : '') + '">' + escapeHTML(t.subtitle) + '</div>';
      html += '</div>';
      html += '<div class="ab-prc">';
      if (t.fullPrice) html += '<span class="ab-full">' + escapeHTML(t.fullPrice) + '</span>';
      html += '<span class="ab-price">' + escapeHTML(t.price) + '</span>';
      html += '</div>';
      html += '</div>';
    });
    html += '</div>';

    if (state.upsell) {
      // split title su "·" → titolo + descrizione
      var upParts = state.upsell.title.split('·').map(function (s) { return s.trim(); });
      var upTitle = upParts[0] || state.upsell.title;
      var upDesc = upParts.slice(1).join(' · ') || 'Aggiungi alla tua selezione';
      var upDisc2 = calcDiscount(state.upsell.price, state.upsell.fullPrice);
      // intro heading
      html += '<div class="ab-upsell-intro">Mai più senza testine · raddoppia la scorta:</div>';
      html += '<div class="ab-upsell' + (state.upsell.checked ? ' ab-up-on' : '') + '">';
      if (upDisc2 > 0) html += '<div class="ab-up-ribbon">−' + upDisc2 + '% · 1 anno</div>';
      html += '<span class="ab-up-check"></span>';
      html += '<img class="ab-up-img" src="' + state.upsell.img + '" alt="">';
      html += '<div class="ab-up-text">';
      html += '<div class="ab-up-title">' + escapeHTML(upTitle) + '</div>';
      html += '<div class="ab-up-sub">' + escapeHTML(upDesc) + '</div>';
      html += '</div>';
      html += '<span class="ab-up-prc">';
      if (state.upsell.fullPrice) html += '<span class="ab-up-full">' + escapeHTML(state.upsell.fullPrice) + '</span>';
      html += '<span class="ab-up-price">' + escapeHTML(state.upsell.price) + '</span>';
      html += '</span>';
      html += '</div>';
    }

    if (state.gifts.length) {
      html += '<div class="ab-gifts-head">';
      html += '<h4>🎁 ' + escapeHTML(state.giftsTitle.replace(/^🎁\s*/, '')) + '</h4>';
      if (state.giftsSub) html += '<p>' + escapeHTML(state.giftsSub) + '</p>';
      html += '</div>';
      html += '<div class="ab-gifts">';
      state.gifts.forEach(function (g) { html += buildGiftHTML(g); });
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function mount(state) {
    var block = state.block;
    var container = document.createElement('div');
    container.className = 'ab-bundle-root';
    container.innerHTML = buildHTML(state);
    block.parentNode.insertBefore(container, block);
    block.style.display = 'none';

    container.querySelectorAll('.ab-tier').forEach(function (tEl) {
      tEl.addEventListener('click', function () {
        var rid = tEl.dataset.radioId;
        if (rid) {
          var radio = document.getElementById(rid);
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            radio.click();
          }
        }
      });
    });

    if (state.upsell) {
      container.querySelector('.ab-upsell')?.addEventListener('click', function () {
        var existing = state.upsell.el;
        var box = existing.querySelector('[role="checkbox"]') || existing.querySelector('.kaching-bundles__checkbox-upsells__checkbox');
        if (box) box.click();
      });
    }

    return container;
  }

  function syncFromKaching(custom, block) {
    var bars = block.querySelectorAll('.kaching-bundles__bars .kaching-bundles__bar');
    bars.forEach(function (bar) {
      if (bar.closest('.kaching-bundles__checkbox-upsells')) return;
      var bid = bar.dataset.dealBarId;
      var tier = custom.querySelector('.ab-tier[data-bar-id="' + bid + '"]');
      if (tier) {
        if (bar.classList.contains('kaching-bundles__bar--selected')) tier.classList.add('ab-sel');
        else tier.classList.remove('ab-sel');
        // re-fetch image se ora il DOM ha src migliore
        var freshImg = bar.querySelector('.kaching-bundles__bar-image');
        if (freshImg && freshImg.src && freshImg.src.indexOf('data:') !== 0) {
          var myImg = tier.querySelector('.ab-img');
          if (myImg && myImg.src !== freshImg.src) myImg.src = freshImg.src;
        }
      }
    });
    var up = block.querySelector('.kaching-bundles__checkbox-upsells__upsell');
    if (up) {
      var box = up.querySelector('[role="checkbox"]');
      var on = box && box.getAttribute('aria-checked') === 'true';
      var abUp = custom.querySelector('.ab-upsell');
      if (abUp) abUp.classList.toggle('ab-up-on', !!on);
    }
    var giftEls = block.querySelectorAll('.kaching-bundles__progressive-gifts__gift');
    var abGifts = custom.querySelectorAll('.ab-gift');
    giftEls.forEach(function (g, i) {
      var ab = abGifts[i];
      if (!ab) return;
      var locked = g.classList.contains('kaching-bundles__progressive-gifts__gift--locked');
      var wasLocked = ab.classList.contains('ab-gift-locked');
      if (locked === wasLocked) return; // no change
      var imgEl = g.querySelector('img');
      var imgSrc = imgEl ? imgEl.src : (ab.querySelector('.ab-gift-real')?.src || '');
      var titleText = g.querySelector('.kaching-bundles__progressive-gifts__gift__title')?.textContent.trim() || '';
      // keep image from ab-gift-real if still present (per locked reveal)
      if (!imgSrc) {
        var prevImg = ab.querySelector('.ab-gift-real');
        if (prevImg) imgSrc = prevImg.src;
      }
      if (!titleText) {
        var prevName = ab.querySelector('.ab-gift-name');
        if (prevName) titleText = prevName.textContent.trim();
      }
      var labelText = g.querySelector('.kaching-bundles__progressive-gifts__gift__label__text:not(.kaching-bundles__progressive-gifts__gift__label__text--crossed-out)')?.textContent.trim() || 'Gratis';
      var crossed = g.querySelector('.kaching-bundles__progressive-gifts__gift__label__text--crossed-out')?.textContent.trim() || '';

      // Lock-break animation when transitioning locked → unlocked
      var isUnlocking = wasLocked && !locked;

      if (isUnlocking) {
        // 1. KEEP locked HTML so the lock-overlay exists during the animation
        ab.className = 'ab-gift ab-gift-locked ab-just-unlocked';
        var lockOv = ab.querySelector('.ab-lock-overlay');
        if (lockOv) {
          lockOv.style.animation = 'none';
          void lockOv.offsetWidth;
          lockOv.style.animation = '';
        }
        // 2. Dopo 450ms: cambia testo "BLOCCATO" → nome reale (lock già parzialmente sceso)
        setTimeout(function () {
          var nameEl = ab.querySelector('.ab-gift-name');
          if (nameEl) {
            nameEl.style.transition = 'opacity .22s ease, color .22s ease';
            nameEl.style.opacity = '0';
            setTimeout(function () {
              nameEl.innerHTML = formatGiftTitle(titleText);
              ab.classList.add('ab-unlocked-name');
              nameEl.style.opacity = '1';
            }, 180);
          }
        }, 450);
        // 3. Dopo 1250ms: cleanup soft — rimuovo SOLO lock-overlay + swap classes (no innerHTML rebuild)
        setTimeout(function () {
          var lockOv2 = ab.querySelector('.ab-lock-overlay');
          if (lockOv2) lockOv2.remove();
          ab.classList.remove('ab-gift-locked', 'ab-just-unlocked', 'ab-unlocked-name');
          ab.classList.add('ab-gift-unlocked');
        }, 1250);
      } else {
        // locking o no-change with refresh: ricostruisci subito
        ab.className = 'ab-gift ' + (locked ? 'ab-gift-locked' : 'ab-gift-unlocked');
        ab.innerHTML = buildGiftHTML({ locked: locked, img: imgSrc, title: titleText, labelText: labelText, crossed: crossed }).replace(/^<div[^>]*>/, '').replace(/<\/div>$/, '');
      }
    });
  }

  function pollMediaImages(custom, block) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (tries > 100) { clearInterval(iv); return; } // 30s max
      var blockEl = document.querySelector('kaching-bundles-block');
      if (!blockEl) return;
      // tenta più sorgenti: attribute, property, deal-block JSON
      var mi = blockEl.getAttribute('media-images') || blockEl.mediaImages;
      if (!mi) return;
      var arr;
      try { arr = typeof mi === 'string' ? JSON.parse(mi) : mi; } catch (e) { return; }
      if (!Array.isArray(arr) || arr.length === 0) return;
      var mediaMap = window.__abMediaMap || (window.__abMediaMap = {});
      var changed = false;
      arr.forEach(function (m) {
        if (m && m.gid && m.url && !mediaMap[m.gid]) {
          mediaMap[m.gid] = m.url;
          changed = true;
        }
      });
      if (!changed) return;
      // aggiorna immagini dei gifts del custom widget (settings della variante idratata)
      var settings = window.__abSettings;
      if (!settings) return;
      var giftConfigs = (settings.progressiveGifts && settings.progressiveGifts.gifts) || [];
      var abGifts = custom.querySelectorAll('.ab-gift');
      giftConfigs.forEach(function (cfg, i) {
        if (!cfg.mediaImageGID || !mediaMap[cfg.mediaImageGID]) return;
        var ab = abGifts[i];
        if (!ab) return;
        var imgEl = ab.querySelector('.ab-gift-real');
        var newUrl = mediaMap[cfg.mediaImageGID];
        if (imgEl && imgEl.src !== newUrl) {
          imgEl.src = newUrl;
        } else if (!imgEl) {
          // nessuna img — la creo
          var wrap = ab.querySelector('.ab-gift-img');
          if (wrap) {
            var img = document.createElement('img');
            img.className = 'ab-gift-real';
            img.src = newUrl;
            img.alt = '';
            wrap.insertBefore(img, wrap.firstChild);
          }
        }
      });
      clearInterval(iv);
    }, 300);
  }

  function init(tries) {
    var state = readState();
    var info = 'try=' + tries + ' state=' + (!!state) + ' tiers=' + (state ? state.tiers.length : '?') + ' imgs=' + (state ? allImagesReady(state) : '?');
    if (tries === 0 || tries % 10 === 0) showDebug(info);

    if (!state || state.tiers.length === 0) {
      if (tries >= MAX_TRIES) { showDebug('FAIL: no state after ' + tries); return; }
      return setTimeout(function () { init(tries + 1); }, WAIT_MS);
    }
    if (state.block.dataset.abMounted) { showDebug('already mounted'); return; }
    state.block.dataset.abMounted = '1';

    // Preselect Offer B (index 1) by default — overrides Kaching's default Offer A
    if (state.tiers.length > 1 && !state.tiers[1].selected) {
      var preRid = state.tiers[1].radioId;
      if (preRid) {
        var preRadio = document.getElementById(preRid);
        if (preRadio) {
          preRadio.checked = true;
          preRadio.dispatchEvent(new Event('change', { bubbles: true }));
          preRadio.click();
        }
      }
      // re-read state so the UI mounts with B already marked selected
      var fresh = readState();
      if (fresh && fresh.tiers.length === state.tiers.length) state = fresh;
    }

    showDebug('mounting tiers=' + state.tiers.length + ' gifts=' + state.gifts.length);
    try {
      var custom = mount(state);
      showDebug('MOUNTED OK');
      setTimeout(function () { var d = document.getElementById('ab-debug'); if (d) d.style.display = 'none'; }, 4000);
      pollMediaImages(custom, state.block);
      var resync = function () { syncFromKaching(custom, state.block); };
      var mo = new MutationObserver(resync);
      mo.observe(state.block, { childList: true, subtree: true, attributes: true });
      document.addEventListener('kaching-bundles:option-changed', resync);
      document.addEventListener('kaching-bundles:hydrated', resync);
    } catch (err) {
      showDebug('ERROR: ' + (err.message || err));
    }
  }

  /* =========================================================================
   * KACHING CART IMAGE FIX
   * Sostituisce le img del Cart drawer con le mediaImage del widget Bundles.
   * Mapping productId → bundleMediaUrl (cached from buildProductImageMap +
   * dealBlockSettings.dealBars[i].mediaImageGID + progressiveGifts.gifts[i].mediaImageGID)
   * ========================================================================= */
  function buildCartImageMap() {
    var map = window.__abCartImgMap || (window.__abCartImgMap = {});
    var mediaMap = window.__abMediaMap || {};
    // Leggo dealBlockSettings per fare il bridge productId → mediaImageGID → url
    var dbs = document.querySelector('script.kaching-bundles-deal-block-settings');
    if (window.__abSettings || dbs) {
      try {
        var settings = window.__abSettings || JSON.parse(dbs.textContent);
        // tiers: dealBars[i].variantGID o productGID → mediaImageGID
        (settings.dealBars || []).forEach(function (bar) {
          var pid = (bar.productGID && bar.productGID.match(/\d+$/)) ? bar.productGID.match(/\d+$/)[0] : null;
          var vid = (bar.variantGID && bar.variantGID.match(/\d+$/)) ? bar.variantGID.match(/\d+$/)[0] : null;
          var mediaUrl = bar.mediaImageGID && mediaMap[bar.mediaImageGID];
          if (mediaUrl) {
            if (pid) map[pid] = mediaUrl;
            if (vid) map['v' + vid] = mediaUrl;
          }
        });
        // checkboxUpsells
        ((settings.checkboxUpsells && settings.checkboxUpsells.upsells) || []).forEach(function (u) {
          var pid = (u.productGID && u.productGID.match(/\d+$/)) ? u.productGID.match(/\d+$/)[0] : null;
          var mediaUrl = u.mediaImageGID && mediaMap[u.mediaImageGID];
          if (pid && mediaUrl) map[pid] = mediaUrl;
        });
        // progressive gifts
        ((settings.progressiveGifts && settings.progressiveGifts.gifts) || []).forEach(function (g) {
          var pid = (g.productGID && g.productGID.match(/\d+$/)) ? g.productGID.match(/\d+$/)[0] : null;
          var mediaUrl = g.mediaImageGID && mediaMap[g.mediaImageGID];
          if (pid && mediaUrl) map[pid] = mediaUrl;
        });
      } catch (e) {}
    }
    return map;
  }

  function swapCartImages() {
    var map = buildCartImageMap();
    if (!Object.keys(map).length) return;
    // line items
    document.querySelectorAll('.kaching-cart-item').forEach(function (item) {
      var img = item.querySelector('.kaching-cart-item__image');
      if (!img) return;
      // try product handle via link, then variant id
      var link = item.querySelector('.kaching-cart-item__link');
      var href = link ? link.getAttribute('href') : '';
      var variantMatch = href && href.match(/variant=(\d+)/);
      var variantId = variantMatch ? variantMatch[1] : null;
      var handleMatch = href && href.match(/\/products\/([^?]+)/);
      // fallback: cerco productId via handle nei kaching-bundles-product
      var productId = null;
      if (handleMatch) {
        var h = decodeURIComponent(handleMatch[1]);
        document.querySelectorAll('script.kaching-bundles-product').forEach(function (s) {
          try {
            var d = JSON.parse(s.textContent);
            if (d.handle === h) productId = String(d.id);
          } catch (e) {}
        });
      }
      var newSrc = (variantId && map['v' + variantId]) || (productId && map[productId]);
      if (newSrc && img.src !== newSrc) img.src = newSrc;
    });
    // upsell carousel items
    document.querySelectorAll('.kaching-product-upsell-item').forEach(function (item) {
      var pid = item.dataset.productId;
      var img = item.querySelector('.kaching-product-upsell-item__image');
      if (pid && img && map[pid] && img.src !== map[pid]) img.src = map[pid];
    });
  }

  function watchCartDrawer() {
    // Kaching Cart drawer nascosto via CSS — niente swap necessario.
    // Mantengo la funzione vuota per non rompere chiamate esistenti.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); watchCartDrawer(); });
  } else {
    init(0);
    watchCartDrawer();
  }
})();
